import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import siteConfig from '../config/siteConfig.json';

const Navigation = () => {
  const { navigation, business } = siteConfig;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <h2>{business.name}</h2>
        </Link>
        
        {/* Hamburger Button - Mobile Only */}
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav-right ${isMenuOpen ? 'mobile-open' : ''}`}>
          <ul className="nav-links">
            {navigation.links.map((link) => (
              <li key={link.path}>
                <Link to={link.path} onClick={closeMenu}>{link.label}</Link>
              </li>
            ))}
          </ul>
          <a 
            href="https://that-time.co.uk/art-aesthetics-skincare" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="nav-book-btn"
            onClick={closeMenu}
          >
            Book Now
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
